module.exports = __webpack_public_path__ + "static/media/check-double.3a15aead.svg";